/**
 * AKADEMIK ESIKLER — sunucu ve arayuz AYNI sayiyi kullanir
 *
 * ================================================================
 * NEDEN BURADA
 * ================================================================
 * Bu sayilar kullaniciya METIN olarak gosteriliyor: "Hukum icin en
 * az 3 soru gerekiyor, 2 var" gibi. Arayuz kendi dosyasina yazdiginda
 * IKI GERCEK olusuyor ve biri sessizce eskiyor.
 *
 * Ayni sinif hata bu projede GERCEKTEN olmustu: panel "Baglanti 7 gun
 * gecerlidir" diyordu, sunucudaki deger 30 dakikaydi ve kullaniciyi
 * calismayan bir baglantiya gonderiyordu (bkz. `kimlik.ts`).
 */

/**
 * Bir konu hakkinda "denemede dogrulandi" ya da "tekrar gerekiyor"
 * demek icin gereken EN AZ soru sayisi — F-TPC-02.
 *
 * Esiksiz bir kural F-TPC-02'yi anlamsiz kilardi: tek soruyu tahminle
 * dogru yapan ogrencinin konusu "dogrulandi", tek soruyu yanlis yapan
 * ogrencinin aylardir calistigi konu "tekrar gerekiyor"a duserdi.
 *
 * UC secildi: iki soruda %50 ile %100 arasinda ara deger yok, yani
 * basari esigi (%60) hicbir zaman anlamli bir ayrim yapamaz.
 *
 * BU BIR URUN KARARI ve Emre'nin onayini bekliyor — `DENEME_ESIGI`
 * gibi ayarlanabilir olup olmayacagi acik (bkz. gorev listesi).
 * Ayarlanabilir yapilirsa sunucu degeri arayuze GONDERMELI; o zamana
 * kadar tek kaynak burasi.
 */
export const KONU_HUKMU_ICIN_EN_AZ_SORU = 3;

/**
 * Acik bir calisma sayacinin TERK EDILMIS sayilma esigi (dakika) —
 * F-STV-06.
 *
 * Kalp atisi bu suredan eskiyse oturum terk edilmis sayilir ve sure
 * SON ATISA kadar yazilir. Simdiye kadar saymak, uyurken gecen
 * saatleri calisma suresi olarak kaydetmek olurdu.
 */
export const TIMER_TERK_ESIGI_DAKIKA = 120;

/**
 * Istemcinin kalp atisi araligi (ms) — F-STV-06.
 *
 * ================================================================
 * IKI SABIT BIRBIRINE BAGLI VE AYRI UYGULAMALARDAYDI
 * ================================================================
 * Esik `apps/api` icinde, aralik `apps/ogrenci` icindeydi; ikisi
 * birbirini TANIMIYORDU. Iliski sessiz ve tek yonlu tehlikeli:
 * aralik esigi gecerse HER oturum ilk atista terk edilmis sayilir ve
 * suresi SIFIR yazilir — ogrenci saatlerce calisir, karnesine sifir
 * girer, hicbir hata cikmaz.
 *
 * Aralik esigin cok altinda olmali, cunku terk edilen oturumun
 * suresi son atisa kadar yaziliyor: aralik ne kadar genisse gercekten
 * calisilan sureden o kadar fazlasi kayboluyor.
 *
 * Iki dakikada saatte otuz istek oluyor; bir ogrencinin ayni anda
 * acik sayaci zaten bir tane.
 */
export const KALP_ARALIGI_MS = 120_000;
